import type { ComponentType, ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface EmptyStateProps {
  icon?: ComponentType<{ className?: string }>;
  /** Optional: omit when the enclosing card already carries the heading. */
  title?: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'relative flex min-h-[320px] flex-col items-center justify-center gap-4 text-center',
        'rounded-lg border border-dashed border-border p-8',
        className,
      )}
    >
      {Icon ? <Icon className="h-12 w-12 text-text-muted" aria-hidden="true" /> : null}
      <div className="flex flex-col gap-1">
        {title ? <h3 className="text-h3 text-text-primary">{title}</h3> : null}
        {description ? (
          <p className="text-body text-text-secondary max-w-[400px]">{description}</p>
        ) : null}
      </div>
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
